module.exports = __webpack_public_path__ + "static/media/pay.12828a0c.svg";